// Shared styles for signup prototypes

export const COLORS = {
  salmon: '#EBA09B',
  peach: '#F5B9A5',
  gold: '#F5D7AA',
  green: '#B5C9A8',
  blue: '#385cbc',
  bg: '#f7f5f3',
  text: '#272726',
  muted: '#666',
  border: '#e0ddd9'
};

export const FONTS = {
  serif: '"Source Serif Pro", Georgia, serif',
  system: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
};

export const inputStyle = {
  width: '100%',
  padding: '14px 16px',
  fontSize: '15px',
  border: `1.5px solid ${COLORS.border}`,
  borderRadius: '6px',
  outline: 'none',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  boxSizing: 'border-box',
  backgroundColor: '#fff',
  fontFamily: FONTS.system
};

export const labelStyle = {
  display: 'block',
  fontSize: '14px',
  fontWeight: '600',
  color: COLORS.text,
  marginBottom: '8px'
};

export const cardStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '48px 40px',
  maxWidth: '480px',
  width: '100%',
  boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
  position: 'relative',
  zIndex: 1
};

export const primaryButtonStyle = {
  padding: '14px 24px',
  fontSize: '16px',
  fontWeight: '600',
  color: '#ffffff',
  backgroundColor: COLORS.text,
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease, transform 0.2s ease'
};

export const secondaryButtonStyle = {
  padding: '14px 24px',
  fontSize: '15px',
  fontWeight: '600',
  color: COLORS.text,
  backgroundColor: 'transparent',
  border: `2px solid ${COLORS.text}`,
  borderRadius: '6px',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease'
};

export const handleInputFocus = (e) => {
  e.target.style.borderColor = COLORS.salmon;
  e.target.style.boxShadow = '0 0 0 3px rgba(235, 160, 155, 0.15)';
};

export const handleInputBlur = (e) => {
  e.target.style.borderColor = COLORS.border;
  e.target.style.boxShadow = 'none';
};

// Kept as no-op for reflect prototype compatibility
export const GradientBanner = () => null;
